// Core
import React from 'react';
import { shallowEqual } from 'react-redux';
// Components
import { LineChart } from '../common/LineChart';
// Hooks:
import { useDatesChartData } from '../../hooks/useDatesChartData';
// Other
import { useTypedSelector } from '../../redux';

export const ModulesPerSession: React.FC = () => {
  const {
    data: { modulesPerSession },
    mode,
    startDate,
    endDate,
  } = useTypedSelector(({ total }) => total, shallowEqual);
  const {
    labelsNames, chartData,
  } = useDatesChartData(mode, modulesPerSession, startDate, endDate);

  return (
    <>
      {chartData.length > 0 && (
      <LineChart
        theme="green"
        title="Website Modules per Session"
        subtitle="Amount open modules per session. One session is one unique user."
        label="Modules"
        labelsNames={labelsNames}
        data={chartData}
      />
      )}
    </>
  );
};
